import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "totalAmountField"]

  connect() {
    this.updateTotal()
  }

  addItem(event) {
    event.preventDefault()

    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML("beforeend", content)
    this.updateTotal()
  }

  removeItem(event) {
    event.preventDefault()

    const item = event.target.closest(".nested-fields")
    item.querySelector("input[name*='_destroy']").value = "1"
    item.style.display = "none"
    this.updateTotal()
  }

  updateTotal() {
    const amountFields = this.containerTarget.querySelectorAll('input[name*="[amount]"]')
    let total = 0

    amountFields.forEach(field => {
      const row = field.closest('.nested-fields')
      const destroyField = row.querySelector('input[name*="_destroy"]')

      // Only include amounts from rows that aren't marked for destruction
      if (!destroyField || destroyField.value !== "1") {
        const value = parseFloat(field.value) || 0
        total += value
      }
    })

    // Update the total amount field in the form
    if (this.hasTotalAmountFieldTarget) {
      this.totalAmountFieldTarget.value = total.toFixed(2)
    }
  }
}
